/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { StatusCssClasses, StatusTitles } from "../../../../../../../_helpers/Helpers";

export const StatusColumnFormatter = (cellContent, row) => (
  <span
    className={`label label-lg label-light-${
      StatusCssClasses[row.isActive]
    } label-inline`}
  >
    {StatusTitles[row.isActive]}
  </span>
);